<div>
  <div class="grid grid-cols-12 body-small gap-1">
    <div class="col-span-7 md:col-span-7">{{ label }}</div>
    <div class="col-span-2 mr-auto">x {{ count }}</div>
    <evsb-currency-xs class="col-span-3 md:col-span-3 ml-auto" [amount]="price"></evsb-currency-xs>
  </div>
  <p *ngIf="description" class="body-small mt-1 text-grey-dark60">{{ description }}</p>
  <span *ngIf="bottomLabel" class="body-small">{{ bottomLabel }}</span>
</div>
